import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WorkersCompLimit } from '../workers-comp';
import { Observable } from 'rxjs';
import { SchoolDistrict } from '../models/tax-config';
import { Office } from '../models/locations';
import { TaxHierarchy } from '../models/payroll';
import { EmailDomainBlacklist } from '../models/admin-models';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(
    private http: HttpClient,
    @Inject('env') private env: any,
    @Inject('errorInterceptorSkipHeader') private errorInterceptorSkipHeader: any
  ) {}

  public getAutoPayClients(payrollDueIn: number = 0): Observable<string[]> {
    return this.http.get<string[]>(
      `${this.env.apiUrlRoot}/Companies/AutomaticPayClients?payrollDueIn=${payrollDueIn}`
    );
  }

  public getHolidays(earliest: Date, latest: Date): Observable<Date[]> {
    return this.http.get<Date[]>(
      `${this.env.apiUrlRoot}/Admin/Holiday?earliestDate=${new Date(
        earliest
      ).toISOString()}&latestDate=${new Date(latest).toISOString()}`
    );
  }

  public GetNthBusinessDay(date: Date, count: number): Observable<Date> {
    const getNthBusinessDayReq = {
      StartingDate: date,
      Days: count
    };

    return this.http.post<Date>(`${this.env.apiUrlRoot}/GetNthBusinessDay`, getNthBusinessDayReq);
  }

  public GetNthPriorBusinessDay(date: Date, count: number): Observable<Date> {
    const getNthPriorBusinessDayReq = {
      StartingDate: date,
      Days: count
    };

    return this.http.post<Date>(
      `${this.env.apiUrlRoot}/GetNthPriorBusinessDay`,
      getNthPriorBusinessDayReq
    );
  }

  public getOfficeCSRMap(): Observable<Office[]> {
    return this.http.get<Office[]>(`${this.env.apiUrlRoot}/OfficeCSRMap`);
  }

  // public getUserPermissions(): Promise<UserPermission[]> {
  //   const headers = new HttpHeaders().set(errorInterceptorSkipHeader, '');
  //   return this.http.get<UserPermission[]>(`${env.authUrl}/authorization`, { headers }).toPromise();
  // }

  public getWorkersCompLimits(): Observable<WorkersCompLimit[]> {
    return this.http.get<WorkersCompLimit[]>(`${this.env.apiUrlRoot}/WorkersCompLimits`);
  }

  public getLocalTaxesByCounty(
    residentState: string
  ): Observable<Record<string, Record<string, SchoolDistrict[]>>> {
    return this.http.get<Record<string, Record<string, SchoolDistrict[]>>>(
      `${this.env.apiUrlRoot}/LocalsByCounty?residentState=${residentState}`
    );
  }

  public checkMobilePhone(phone: string): Observable<boolean> {
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');
    return this.http.post<boolean>(
      `${this.env.apiUrlRoot}/Companies/CheckMobilePhone`,
      { PhoneNumber: phone },
      { headers }
    );
  }

  public getTaxHierarchy(): Observable<TaxHierarchy[]> {
    //We want to cache these requests, one hour
    let headers = new HttpHeaders();
    headers = headers.set('X-Cache-Lifetime', '3600');

    return this.http.get<TaxHierarchy[]>(`${this.env.apiUrlRoot}/Admin/TaxHierarchy`, { headers });
  }

  public getEmailDomainBlacklist(): Observable<EmailDomainBlacklist> {
    //We want to cache these requests, one hour
    let headers = new HttpHeaders();
    headers = headers.set('X-Cache-Lifetime', '3600');
    return this.http.get<EmailDomainBlacklist>(
      `${this.env.apiUrlRoot}/Admin/EmailDomainBlacklist`,
      { headers }
    );
  }
}
